import { PluginFunc } from 'dayjs';

import { TimeExpressionOptions } from '../type';

const plugin: PluginFunc<TimeExpressionOptions> & { $i: boolean } = function (options, dayjsClass, dayjs) {
  const proto = dayjsClass.prototype;
  const { justNowThreshold } = options;

  proto.getTimeExpression = (start, end): string => {
    const startTime = dayjs(start);
    const endTime = dayjs(end);
    const { justNow, today, tomorrow, yesterday } = endTime.$locale();
    const absDiff = Math.abs(startTime.diff(endTime, 'ms', true));

    if (absDiff <= justNowThreshold) {
      return justNow;
    }

    if (startTime.isSame(endTime, 'day')) {
      return today;
    }

    if (startTime.add(1, 'day').isSame(endTime, 'day')) {
      return tomorrow;
    }

    if (startTime.subtract(1, 'day').isSame(endTime, 'day')) {
      return yesterday;
    }

    return '';
  };
};

/**
 * used inside dayjs.extend to
 * register/unregister timeExpression plugin
 */
plugin.$i = false;

export default plugin;
